import { COLORS } from '@btime/constants'
import React from 'react'

import WorkReport from './workReport/WorkReport'
import WorkSafetyReport from './workSafetyReport/WorkSafetyReport'
import WorkReportNaturalEnvironment from './workReportNaturalEnvironment/workReportNaturalEnvironment'

import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Preview from '../../../..../../components/pdf/Preview'
import Center from '../../../packages/kiti/components/helpers/Center'
import IconBlock from '../../../components/presentation/IconBlock'
import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'

const PageContent = ({ templateId }) => {
  let content

  if (templateId === 1) {
    content = <WorkReport />
  } else if (templateId === 2) {
    content = <WorkSafetyReport />
  } else if (templateId === 3) {
    content = <WorkReportNaturalEnvironment />
  } else {
    content = (
      <Center>
        <IconBlock
          icon="RiFileWarningLine"
          title="Não foi possível gerar esse relatório"
          subtitle="Documento não suportado"
        ></IconBlock>
      </Center>
    )
  }

  return (
    <PdfOptionsFormHandler initialState={{ fontBaseColor: COLORS.dark1 }}>
      <Grid align="stretch">
        <Col flex={3} flex_mdd={0} hideOn="mdd" scroll height="calc(100vh - 4.3rem)">
          <Preview>{content}</Preview>
        </Col>
      </Grid>
    </PdfOptionsFormHandler>
  )
}

export default PageContent
